import { SVGProps } from 'react';

const SvgPhone = (props: SVGProps<SVGSVGElement>) => (
  <svg width={24} height={24} fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fill="#081930"
      fillRule="evenodd"
      d="M14.095 18.464a23.327 23.327 0 0 0 3.41 1.41c.554.178 1.192.015 1.672-.465l.386-.386-3.55-2.477-1.918 1.918Zm-1.803-1.026 2.306-2.306a2 2 0 0 1 2.559-.226l3.55 2.476a2 2 0 0 1 .27 3.055l-.386.386c-.94.94-2.34 1.392-3.699.955-2.14-.689-6.065-2.295-9.337-5.568-3.273-3.273-4.88-7.197-5.568-9.337-.437-1.359.015-2.76.955-3.7l.386-.386a2 2 0 0 1 3.055.27l2.476 3.551a2 2 0 0 1-.226 2.558l-2.306 2.306a19.321 19.321 0 0 0 2.642 3.324 19.32 19.32 0 0 0 3.323 2.642ZM5.301 9.67l1.918-1.918-2.477-3.55-.386.386c-.48.48-.644 1.118-.465 1.672.285.885.736 2.088 1.41 3.41Z"
      clipRule="evenodd"
    />
  </svg>
);

export default SvgPhone;
